import { render, staticRenderFns } from "./swiperCard.vue?vue&type=template&id=2f4bc00c&scoped=true"
import script from "./swiperCard.vue?vue&type=script&lang=js"
export * from "./swiperCard.vue?vue&type=script&lang=js"
import style0 from "./swiperCard.vue?vue&type=style&index=0&id=2f4bc00c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_f33b182414a87044fb4ff91041025cb4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4bc00c",
  null
  
)

export default component.exports